import React from "react";
import { CloudPremisePluginMenu } from "@cloudpremise/portal_core";

const settingMenus = (): CloudPremisePluginMenu[] => {
    return [
        {
            name: "Setup Service Desk",
            key: "setupservicedesk",
            route: "/servicedesk/setup",
            privacy: "private",
        },
    ];
};

export default settingMenus;